import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Allcategories from "../Body/Allcategories";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-1 px-4 md:px-6">
        {/* Categories / Doctors */}
        <section className="mt-4 md:mt-6">
          <Allcategories />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
